import styled from 'styled-components';
import { SIDEBAR_PADDING, LOGOTYPE_PADDING } from '../config.js';
import { Logotype } from '../../../foundation/Logotype/index.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var SidebarMenuHeaderContainer = styled.div.withConfig({
  displayName: "SidebarMenuHeaderContainer",
  componentId: "sc-ou235a-0"
})(["display:flex;flex-direction:column;flex-shrink:0;gap:", ";padding:", ";"], SIDEBAR_PADDING, SIDEBAR_PADDING);
var StyledLogotype = styled(Logotype).withConfig({
  displayName: "StyledLogotype",
  componentId: "sc-ou235a-1"
})(["width:auto;height:", ";padding-left:", ";"], pxToRem(16), LOGOTYPE_PADDING);

export { SidebarMenuHeaderContainer, StyledLogotype };
